import CrudRepository from './CrudRepository'
export default class FinancialReportsYearsRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/financeReport/years')
  }
}
